export default __webpack_public_path__ + "audio/a494c5faac8ac608b2dd744a0fc6d275-crush.wav";